var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isScheduledActivity && _vm.themeLoaded ? _c('div', {
    class: _vm.isSpeedyKid ? 'speedy-kid-award' : '',
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.totalBlocks ? _c('h1', {
    staticClass: "award-title",
    attrs: {
      "aria-live": "polite",
      "role": "region"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.totalBlocksCompleted) + " out of " + _vm._s(_vm.totalBlocks) + " Activities Completed\n  ")]) : _vm._e(), !_vm.isSpeedyKid ? _c('div', [_c('ul', {
    staticClass: "blockHolder"
  }, _vm._l(_vm.behaviour, function (item, index) {
    return _c('award-block', {
      key: ("awardblock-" + index),
      attrs: {
        "active": item.active,
        "animate": item.animate,
        "bgcolor": item.bgColor,
        "blockIndex": index + 1,
        "theme": item.theme,
        "totalNumberOfBlocks": _vm.behaviour.length
      }
    });
  }), 1), _c('button', {
    ref: "continuebutton",
    staticClass: "award-button-continue",
    attrs: {
      "aria-label": "Continue",
      "tabindex": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.button)
    },
    on: {
      "click": _vm.getNextActivity
    }
  })]) : _c('div', {
    staticClass: "blockAndFlagHolderContainer"
  }, [_c('div', {
    staticClass: "flagHolder"
  }, [_c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "pyramidFlag",
    style: {
      backgroundImage: ("url(" + (_vm.pyramidFlag) + "), none")
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star21",
    class: {
      done: _vm.star21
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star19",
    class: {
      done: _vm.star19
    }
  }), _c('div', {
    staticClass: "starFiller star20",
    class: {
      done: _vm.star20
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star16",
    class: {
      done: _vm.star16
    }
  }), _c('div', {
    staticClass: "starFiller star17",
    class: {
      done: _vm.star17
    }
  }), _c('div', {
    staticClass: "starFiller star18",
    class: {
      done: _vm.star18
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star12",
    class: {
      done: _vm.star12
    }
  }), _c('div', {
    staticClass: "starFiller star13",
    class: {
      done: _vm.star13
    }
  }), _c('div', {
    staticClass: "starFiller star14",
    class: {
      done: _vm.star14
    }
  }), _c('div', {
    staticClass: "starFiller star15",
    class: {
      done: _vm.star15
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star7",
    class: {
      done: _vm.star7
    }
  }), _c('div', {
    staticClass: "starFiller star8",
    class: {
      done: _vm.star8
    }
  }), _c('div', {
    staticClass: "starFiller star9",
    class: {
      done: _vm.star9
    }
  }), _c('div', {
    staticClass: "starFiller star10",
    class: {
      done: _vm.star10
    }
  }), _c('div', {
    staticClass: "starFiller star11",
    class: {
      done: _vm.star11
    }
  })]), _c('div', {
    staticClass: "flagRow"
  }, [_c('div', {
    staticClass: "starFiller star1",
    class: {
      done: _vm.star1
    }
  }), _c('div', {
    staticClass: "starFiller star2",
    class: {
      done: _vm.star2
    }
  }), _c('div', {
    staticClass: "starFiller star3",
    class: {
      done: _vm.star3
    }
  }), _c('div', {
    staticClass: "starFiller star4",
    class: {
      done: _vm.star4
    }
  }), _c('div', {
    staticClass: "starFiller star5",
    class: {
      done: _vm.star5
    }
  }), _c('div', {
    staticClass: "starFiller star6",
    class: {
      done: _vm.star6
    }
  })])]), _c('button', {
    ref: "continuebutton",
    staticClass: "award-button-continue",
    attrs: {
      "tabindex": "0",
      "aria-label": "Continue"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.button)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.getNextActivity($event);
      }
    }
  })])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }